function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 357972",
  d: "M28.117 13.462c-.251.025-1.342 0-1.594 0a8.2 8.2 0 01-6.859-3.707v12.622a9.329 9.329 0 11-9.33-9.33h0c.195 0 .386.018.577.03v4.6a4.751 4.751 0 10-.577 9.465 4.878 4.878 0 004.953-4.7l.046-21.439h4.4a8.193 8.193 0 007.55 7.315V14.3h0",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 2
});

function SvgIconTiktokOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.278 32.708",
    className: "w-full h-full"
  }, props), _ref);
}

export default SvgIconTiktokOutline;